'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStrategy;
var CONFIGURATION_DOM_SELECTOR = '.js-diffusionTopicSettings';
var CONFIGURATION_API_URL_PROPERTY = 'data-diffusion-stub-url';
var CONFIGURATION_HOST_PROPERTY = 'data-diffusion-host';
var CONFIGURATION_PORT_PROPERTY = 'data-diffusion-port';
var CONFIGURATION_SECURE_PROPERTY = 'data-diffusion-secure';
var CONFIGURATION_PRINCIPAL_PROPERTY = 'data-diffusion-principal';
var CONFIGURATION_CREDENTIALS_PROPERTY = 'data-diffusion-credentials';

function createStrategy() {
    return {
        getConfig: function getConfig() {
            var diffusionServerConfig = global.document.querySelector(CONFIGURATION_DOM_SELECTOR);

            if (!diffusionServerConfig) {
                throw new Error('There is no diffusion configuration node');
            }

            var host = diffusionServerConfig.getAttribute(CONFIGURATION_HOST_PROPERTY);
            var port = diffusionServerConfig.getAttribute(CONFIGURATION_PORT_PROPERTY);
            var secure = diffusionServerConfig.getAttribute(CONFIGURATION_SECURE_PROPERTY);
            var principal = diffusionServerConfig.getAttribute(CONFIGURATION_PRINCIPAL_PROPERTY);
            var credentials = diffusionServerConfig.getAttribute(CONFIGURATION_CREDENTIALS_PROPERTY);

            return {
                host: host,
                port: Number(port),
                secure: secure === 'true', // we are taking it as a string, but we need boolean
                principal: principal,
                credentials: credentials
            };
        },
        getStubConfig: function getStubConfig() {
            var diffusionServerConfig = global.document.querySelector(CONFIGURATION_DOM_SELECTOR);
            var url = diffusionServerConfig ? diffusionServerConfig.getAttribute(CONFIGURATION_API_URL_PROPERTY) + 'api/' : null;
            return {
                url: url
            };
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/domConfigurationStrategy.js
// module id = 754
// module chunks = 1